import { QueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
      throwOnError: (error: unknown) =>
        error instanceof AxiosError &&
        (!error?.response?.status ||
          error?.response?.status === 404 ||
          error?.response?.status >= 500),
    },
  },
});
